import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatTableDataSource, MatPaginator, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { AppService } from "src/_services/app.service";
import * as moment from "moment";
import { CommonModalComponent } from "src/app/pages/common-dialog-management/common-dialog.component";
import { Router, ActivatedRoute } from "@angular/router";
import { BetConfigReqParams } from "src/_models";
import {
  roleTypeOperator,
  roleTypeSap,
  disableConfigData,
  SapRoles,
} from "src/_constants/roleType";
import { Location } from "@angular/common";

@Component({
  selector: "app-event-management",
  templateUrl: "./event-management.component.html",
  styleUrls: ["./event-management.component.scss"],
})
export class EventManagementComponent implements OnInit {
  DisplayedColumns: string[] = [
    "Schedule",
    "Competition",
    "EventId",
    "EventName",
    "Favourite",
    "Status",
    "Action",
  ];
  eventsData = new MatTableDataSource<any>();
  competitionData = new MatTableDataSource<any>();
  operatorData = new MatTableDataSource<any>();
  providers = [];
  sportsData = [];
  count: number = 0;
  ProviderId: string = "";
  OperatorId: string = "";
  title: string = "Provider Management";
  competitionId: string = "";
  sportId: string = "all";
  selectedSport = "all";
  selectedCompetition = "all";
  selectedCompStatus = false;
  showOperatorData: boolean = false;
  showSAPData: boolean = false;
  sapRoles = SapRoles;
  starDate: number = 0;
  endDate: number = 0
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  configData: any;

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) {}

  ngOnInit() {
    if (this.sapRoles.RolexAdmin === this.userRole.role) {
      this.DisplayedColumns = [
        "Schedule",
        "Competition",
        "EventId",
        "EventName",
        "Status",
      ];
    }
    if (disableConfigData.includes(this.userRole.role)) {
      this.DisplayedColumns = this.DisplayedColumns.filter(
        (item) => item !== "Action"
      );
    }
    this.route.queryParamMap.subscribe(params => {
      this.starDate = parseInt(params.get('startDate'));
      this.endDate = parseInt(params.get('endDate'));
    });
    if (Number.isNaN(this.starDate) || Number.isNaN(this.endDate) || this.starDate == undefined || this.endDate == undefined || this.starDate == null || this.endDate == null) {
      let start: any =  moment().subtract(5, "days").startOf("day");
      let end: any =  moment().add(2, "days").endOf("day");
      this.starDate = new Date(start).getTime();
      this.endDate =  new Date(end).getTime();
    }
    this.showOperatorData = roleTypeOperator.includes(this.userRole.role) || this.userRole.role === SapRoles.GroupAdmin;
    this.showSAPData = roleTypeSap.includes(this.userRole.role);
    this.OperatorId = this.route.snapshot.params.operator;
    this.ProviderId = this.route.snapshot.params.provider;
    this.sportId = this.route.snapshot.params.sport;
    this.competitionId = this.route.snapshot.params.competition;
    this.addCashoutScorecardColumnsIfEligible();
    // this.onChangeSports(this.sportId)
    this.onChangeCompetition(this.route.snapshot.params.competition);
    // this.getOurProviders();
    if (this.userRole.role === SapRoles.GroupAdmin) {
      this.title = this.OperatorId + " / " + this.title;
    }
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  private addCashoutScorecardColumnsIfEligible() {
    if (!this.isBetfairProvider() || !this.isSapAdmin()) {
      return;
    }
    if (
      this.DisplayedColumns.includes("Cashout") ||
      this.DisplayedColumns.includes("Scorecard")
    ) {
      return;
    }
    const statusIndex = this.DisplayedColumns.indexOf("Status");
    if (statusIndex !== -1) {
      this.DisplayedColumns.splice(statusIndex, 0, "Cashout", "Scorecard");
    } else {
      this.DisplayedColumns.push("Cashout", "Scorecard");
    }
  }

  private isBetfairProvider(): boolean {
    return String(this.ProviderId || "").toLowerCase() === "betfair";
  }

  private isSapAdmin(): boolean {
    return String(this.userRole && this.userRole.role ? this.userRole.role : "") === this.sapRoles.SAPAdmin;
  }

  goTo(link) {
    let linkRoute = `/administration/providers/${this.OperatorId}/${this.ProviderId}/${this.sportId}/${this.route.snapshot.params.competition}/${link.eventId}`;
    this.router.navigate([linkRoute]);
  }

  goToLink(link) {
    this.router.navigate([link]);
  }

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onSelectedProvider = async (pid) => {
    this.eventsData = new MatTableDataSource<any>();
    this.ProviderId = pid;
    this.selectedSport = "all";
    this.getSportData(pid);
  };

  getSportData = (pid) => {
    try {
      let oid = this.OperatorId;
      this.appService.getSportCatalogData(oid, pid).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsData = res.sports;
        }
      });
    } catch (err) {}
  };

  onChangeSports = (sid) => {
    this.sportId = sid;
    this.getOurCompetition(this.ProviderId, this.sportId);
    this.getOurEvent(this.ProviderId, this.sportId, "");
  };

  getOurCompetition = (pid, sid) => {
    try {
      let oid = this.OperatorId;
      this.appService.getRecentCompetitionData(oid, pid, sid).subscribe((res) => {
        if (res.status === "RS_OK") {
          res.Competition.sort((a, b) => {
            const aDesc = a.CompetitionName;
            const bDesc = b.CompetitionName;
            if (aDesc > bDesc) return 1;
            else if (aDesc < bDesc) return -1;
            return 0;
          });
          this.competitionData = res.Competition;
          this.selectedCompetition = "all";
          if (!this.competitionData) {
            this.getOurEvent(this.ProviderId, this.sportId, "-1");
          }
        }
      });
    } catch (err) {}
  };
  onChangeCompetition = (cid) => {
    // let data: any = this.competitionData;
    // console.log('data::: ', data)
    // this.selectedCompetition = cid;
    // this.selectedCompStatus = data.filter(
    //   (item) => item.CompetitionId === cid
    // )[0].status;
    this.getOurEvent(this.ProviderId, this.sportId, cid);
  };
  getOpenDate(date: number) {
    let d = new Date(
      moment.unix(date / 1000).format("YYYY-MM-DD HH:mm")
    ).toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
    return moment(d).format("YYYY-MM-DD HH:mm");
  }
  getOurEvent = (pid, sid, cid) => {
    try {
      let oid = this.OperatorId;
      this.appService
        .getEventsCatalogData(oid, pid, sid, cid === "all" ? "" : cid, this.starDate,this.endDate)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.eventsData = new MatTableDataSource<any>(res.events);
            this.eventsData.paginator = this.paginator;
          }
        });
    } catch (err) {}
  };

  handleChangeStatus(e, data) {
    if (e.checked) {
      this.appService
        .unBlockEvent(
          this.OperatorId,
          this.ProviderId,
          this.sportId,
          data.competitionId,
          data.eventId
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.getOurEvent(this.ProviderId, this.sportId, data.competitionId);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.appService
        .blockEvent(
          this.OperatorId,
          this.ProviderId,
          this.sportId,
          data.competitionId,
          data.eventId
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.getOurEvent(this.ProviderId, this.sportId, data.competitionId);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }
  }

  handleChangeFavourate(e, data) {
    if (e.checked) {
      this.appService
        .setetFavoriteEvent(
          this.OperatorId,
          this.ProviderId,
          this.sportId,
          data.eventId,
          e.checked ? true : false
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Added to Favourite Successfully");
            this.getOurEvent(this.ProviderId, this.sportId, "");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.appService.openErrorBar(
        "Unable to remove from Favourite, contact upline"
      );
    }
  }

  getEventCashout(event: any): boolean {
    return !!(event && (event.cashout === true));
  }

  getEventScorecard(event: any): string {
    return String(
      event && (event.scorecard !== undefined ? event.scorecard : "")
    ).toLowerCase();
  }

  handleCashoutChange(e: any, data: any) {
    const payload = {
      providerId: this.ProviderId,
      sportId: this.sportId,
      eventId: data.eventId,
      cashout: !!(e && e.checked),
    };
    this.appService.updateEventFields(payload).subscribe(
      (res) => {
        if (res.status === "RS_OK") {
          data.cashout = payload.cashout;
          this.appService.openSuccessBar(res.errorDescription || "Cashout updated");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      },
      () => {
        this.appService.openErrorBar("Failed to update cashout");
      }
    );
  }

  onScorecardChange(scorecard: string, data: any) {
    const payload = {
      providerId: this.ProviderId,
      sportId: this.sportId,
      eventId: data.eventId,
      scorecard: String(scorecard || "").toLowerCase(),
    };
    this.appService.updateEventFields(payload).subscribe(
      (res) => {
        if (res.status === "RS_OK") {
          data.scorecard = payload.scorecard;
          this.appService.openSuccessBar(res.errorDescription || "Scorecard updated");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      },
      () => {
        this.appService.openErrorBar("Failed to update scorecard");
      }
    );
  }

  goBack = () => {
    this.location.back();
  };
  changeStatus = (data) => {
    if (this.showSAPData) {
      try {
        this.appService
          .getOperatorsData({
            ProviderId: this.ProviderId,
            SportId: this.sportId,
            CompetitionId: "",
            EventId: data.eventId,
          })
          .subscribe((res) => {
            if (res.status === "RS_OK") {
              this.operatorData.data = res.providers;
              this.dialog.open(CommonModalComponent, {
                backdropClass: "backdropBackground",
                hasBackdrop: true,
                data: {
                  providersStatus: this.operatorData,
                  title: data.eventName,
                  proStatus: data.Status,
                  ProviderId: this.ProviderId,
                  sportId: this.sportId,
                  CompetitionId: data.competitionId,
                  EventId: data.eventId,
                  For: "SAP",
                  code: 0,
                  level: "event",
                },
              });
            }
          });
      } catch (err) {}
    }
  };

  handleClick(data) {
    try {
      const postBody: BetConfigReqParams = {
        ConfigCall: "event",
        PartnerId: data.partnerId,
        ProviderId: this.ProviderId,
        SportId: this.sportId,
        CompetitionId: data.competitionId,
        EventId: data.eventId,
        OperatorId: this.OperatorId,
      };

      this.dialog.open(CommonModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          ConfigData: null, //
          ConfigCall: null, //
          For: "OP",
          page: "event",
          OperatorId: this.OperatorId,
          ProviderId: this.ProviderId,
          SportId: this.sportId,
          CompetitionId: data.competitionId,
          EventId: data.eventId,
          apiReqBody: postBody,
        },
      });
    } catch (err) {}
  }

  getExportExcel() {
    try {
      this.appService
        .getEventsDataList(this.ProviderId, this.sportId, this.competitionId)
        .subscribe((res) => {
          const contentType = "application/vnd.ms-excel";
          let blob1 = this.b64toBlob(res.file, contentType);
          let blobUrl1 = URL.createObjectURL(blob1);
          const link = document.createElement("a");
          link.href = blobUrl1;
          link.setAttribute("download", `catalogue-events.xlsx`);
          document.body.appendChild(link);
          link.click();
        });
    } catch (err) {}
  }

  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  navigateToMarket(ele){
    this.router.navigateByUrl(`/administration/providers/${this.OperatorId}/${this.ProviderId}/${this.sportId}/${this.competitionId}/${ele.eventId}/${ele.eventName}/add-market`)
  }

  getThumbnails = (data) => {
    let dialogRef = this.dialog.open(ThumbnailModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        providerId: this.ProviderId,
        sportId: this.sportId,
        eventId: data.eventId,
        thumbnail: data.thumbnail,
      },
    });  
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getOurEvent(this.ProviderId, this.sportId, data.competitionId);
      }
    }); 
  };
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./thumbnail-modal-component.html",
  styleUrls: ["./event-management.component.scss"],
})
export class ThumbnailModalComponent {
  thumbnails = [];
  errorimgs = [];
  fd = new FormData();
  selectedThumbnail = this.data.thumbnail;
  newThumbnail: File = null;
  constructor(
    public dialogRef: MatDialogRef<ThumbnailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.getThumbnails();
  }

  getThumbnails() {
    if (this.data.sportId && this.data.eventId && this.data.providerId) {
      let filters = {
        providerId : this.data.providerId,
        sportId : this.data.sportId,
        eventId : this.data.eventId,
      }
        try {
          this.appService
            .getThumbnails(
              filters
            )
            .subscribe((res) => {
              if (res.status === "RS_OK") {
                this.thumbnails = res.thumbnails;
              } else {
                this.appService.openErrorBar(res.errorDescription);
                if (res.errorDescription === "Invalid Token!") {
                  sessionStorage.clear();
                  this.router.navigateByUrl("/login");
                }
              }
            });
        } catch (err) {
          console.error("Error fetching thumbnails", err);
        }
    }
  }

  uploadThumbnail() {
    if (this.data.sportId && this.data.eventId && this.data.providerId) {
        try {
          this.appService
            .uploadEventThumbnail(
              this.fd
            )
            .subscribe((res) => {
              this.fd = new FormData();
              if (res.status === "RS_OK") {
                this.appService.openSuccessBar("Uploaded Successfully");
                this.dialogRef.close();
              } else {
                this.appService.openErrorBar(res.errorDescription);
                if (res.errorDescription === "Invalid Token!") {
                  sessionStorage.clear();
                  this.router.navigateByUrl("/login");
                }
              }
            });
        } catch (err) {
          console.error("Error fetching thumbnails", err);
        }
    }
  }

  onFileSelected(event,url) {
    this.newThumbnail = <File>event.target.files[0];
    this.handleFileInput(event, url);
  }

  handleFileInput(event: any, url): void {
    const file: File = event.target.files[0];
    this.fd.append("url", url);
        this.fd.append(
          "thumbnail",
          file,
          file.name
        )
    this.uploadThumbnail()
  }

  selectThumbnail(thumbnail) {
    if(!this.errorimgs.includes(thumbnail)) {
    this.selectedThumbnail = thumbnail;
    }
  }

  onImageError(thumbnail) {
    if(!this.errorimgs.includes(thumbnail)) {
      this.errorimgs.push(thumbnail);
    }
  }

  submitThumbnail() {
    if (this.selectedThumbnail != "") {
      let filters = {
        providerId : this.data.providerId,
        sportId : this.data.sportId,
        eventId : this.data.eventId,
        thumbnail : this.selectedThumbnail,
      }
        try {
          this.appService
            .updateThumbnail(
              filters
            )
            .subscribe((res) => {
              if (res.status === "RS_OK") {
                this.appService.openSuccessBar("Updated Successfully");
                this.dialogRef.close(true);
              } else {
                this.appService.openErrorBar(res.errorDescription);
                if (res.errorDescription === "Invalid Token!") {
                  sessionStorage.clear();
                  this.router.navigateByUrl("/login");
                }
              }
            });
        } catch (err) {
          console.error("Error fetching thumbnails", err);
        }
    }
  }
}